module.exports = __webpack_public_path__ + "static/media/normal-filly.63e70010.png";